import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { notifyAppReady, initLiveUpdates } from "./lib/liveUpdate";

// 네이티브: 현재 번들이 정상임을 즉시 알림(롤백 방지) → 백그라운드로 OTA 업데이트 확인.
// 웹에선 둘 다 no-op. 앱 렌더는 막지 않는다.
void notifyAppReady();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void initLiveUpdates();
